import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/bonuses"; // Matches the backend route in server.ts

// Fetch Bonuses
export const fetchBonuses = createAsyncThunk("bonuses/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  console.log("Fetch Bonuses Response:", response.data);
  return response.data;
});

// Add Bonus
export const addBonus = createAsyncThunk("bonuses/add", async (bonusData) => {
  const response = await hrmsPostRequest(API_URL, bonusData);
  return response.data;
});

// Update Bonus
export const updateBonus = createAsyncThunk("bonuses/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Bonus
export const deleteBonus = createAsyncThunk("bonuses/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

const bonusSlice = createSlice({
  name: "bonuses",
  initialState: {
    bonuses: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBonuses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBonuses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.bonuses = action.payload;
      })
      .addCase(fetchBonuses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addBonus.fulfilled, (state, action) => {
        state.bonuses.push(action.payload);
      })
      .addCase(updateBonus.fulfilled, (state, action) => {
        const index = state.bonuses.findIndex((b) => b.id === action.payload.id);
        if (index !== -1) {
          state.bonuses[index] = action.payload;
        }
      })
      .addCase(deleteBonus.fulfilled, (state, action) => {
        state.bonuses = state.bonuses.filter((b) => b.id !== action.payload);
      });
  },
});

export default bonusSlice.reducer;